import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Drawer,
  Tag,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";

import {
  BarcodeOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  FilePdfOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  materialTypeService,
  measurementTypeService,
  packingTypeService,
  stockClassificationService,
} from "_services";
import TabMenu from "./TabMenu";

let lineIndex = 0;

function Summary({ history, match }) {
  const { id, status } = match.params;

  const { path } = match;

  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [stockTypeMode, setStockTypeMode] = useState("OPEN");
  const [packingTypes, setPackingTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  //const [qualityTypes, setQualityTypes] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [materialLines, setMaterialLines] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [loadingAddEditStockItem, setLoadingAddEditStockItem] = useState(false);

  const [addEditStockItemForm] = Form.useForm();

  useEffect(() => {
    setIsLoading(true);
    materialTypeService
      .getById(id)
      .then((x) => {
        let data = x.content;
        setIsLoading(false);
        setStockType(x.content);
        setMaterialLines(x.content.materials);
        setStockTypeMode(x.content.mode ?? "OPEN");

        onFill(data);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
    packingTypeService.getSuggestion().then((x) => {
      setPackingTypes(x.content);
    });
    stockClassificationService.getSuggestion().then((x) => {
      setStockClasses(x.content);
    });
    getMeasurements();
  }, [stockTypeMode]);

  const getMeasurements = () => {
    measurementTypeService
      .getSuggestion()
      .then((x) => {
        setMeasurementTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const getRowBykey = (key, newData) => {
    return (materialLines || newData).filter((item) => item.key === key)[0];
  };

  const handleStatusUpdate = () => {
    let updateStockPayload = { ...stockType };

    if (stockType.mode === "OPEN") {
      updateStockPayload.mode = "UPDATE";
    } else {
      updateStockPayload.mode = "COMPLETE";
    }

    materialTypeService
      .update(id, updateStockPayload)
      .then((x) => {
        setStockTypeMode(updateStockPayload.mode);
        setIsLoading(false);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleLineEdit = (record) => {
    addEditStockItemForm.setFieldsValue(record);

    setEditDrawerVisible(true);
  };

  const getLineColumns = () => {
    let columns = [];

    columns.push({
      title: "HS Code",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        if (text) {
          return `${text.code}`;
        }
      },
    });
    columns.push({
      title: "Material Code",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        // if (text) {
        //   return `${text.secondaryCode}`;
        // }

        return (
          text?.secondaryCode.toString().substring(0, 16) +
          text?.secondaryCode.toString().slice(-5)
        );
      },
    });
    columns.push({
      title: "Description",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        if (text) {
          return `${text.name}`;
        }
      },
    });
    columns.push({
      title: "Package type",
      dataIndex: ["materialType", "packingType", "name"],
      key: "packageType",
    });

    columns.push({
      title: "Quantity Per Unit",
      dataIndex: "quantityPerUnit",
      key: "quantityPerUnit",
      align: "center",
    });
    columns.push({
      title: "Conversion Ratio",
      dataIndex: "conversionRatio",
      key: "conversionRatio",
      align: "center",
    });
    columns.push({
      title: "Wastage (%)",
      dataIndex: "wastagePercentage",
      align: "center",
      key: "wastagePercentage",
    });
    columns.push({
      title: "UOM",
      dataIndex: "uom",
      key: "uom",
      render: (text, record) => {
        if (text) {
          return text.name;
        }
      },
    });
    columns.push({
      title: "Available Quantity",
      dataIndex: "availableQuantity",
      align: "center",
      key: "availableQuantity",
      render: (text, record) => text ?? "0",
    });

    if (stockType?.mode == "UPDATE") {
      columns.push({
        title: "Action",
        key: "action",
        width: "6%",
        render: (text, record) => {
          return (
            //When need to check the line open or not ["OPEN"].includes(record.lineStage) &&
            <span>
              {
                <Button
                  icon={<EditOutlined />}
                  title="Edit"
                  type="link"
                  style={{ marginRight: 10 }}
                  onClick={() => handleLineEdit(record)}
                ></Button>
              }
              {/* {
              <Popconfirm
                title="Are you sure to delete this line?"
                onConfirm={() => handleLineDelete(record.id)}
              >
                <CloseOutlined
                  loading={loadingLineDelete && record.key === activeTabKey}
                />
              </Popconfirm>
            } */}
            </span>
          );
        },
      });
    }

    return columns;
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/material-types");
  };

  const onCloseAddEditStockItemDrawer = () => {
    setEditDrawerVisible(false);
  };

  const handleAddEditStockItem = (item) => {
    let currentItem = { ...stockType };

    addEditStockItemForm
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        const modifiedList = currentItem.materials.map((material) => {
          if (material.id === values.id) {
            return {
              ...material,
              quantityPerUnit: values.quantityPerUnit,
              materialType: {
                ...material.materialType,
                code: values.materialType.code,
                secondaryCode: values.materialType.secondaryCode,
                name: values.materialType.name,
              },
            };
          }
          return material;
        });

        const modifieditem = { ...currentItem, materials: [...modifiedList] };

        setStockType(modifieditem);
        setIsLoading(false);
        setEditDrawerVisible(false);
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (stockType?.mode !== "COMPLETE") {
      let statusButtonText = "";
      if (stockType?.mode === "OPEN") {
        statusButtonText = "Update State";
      } else if (stockType?.mode === "UPDATE") {
        statusButtonText = "Complete";
      }
      buttons.push(
        <Popconfirm
          placement="left"
          title={`Are you sure to ${statusButtonText} it?`}
          onConfirm={(e) => {
            e.preventDefault();
            handleStatusUpdate();
          }}
          key="con-status-change"
        >
          <Button>{statusButtonText}</Button>
        </Popconfirm>
      );
    }
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/boms">Boms</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {/* <Link to={`${path}`}> BOM Summery of {stockType.name}</Link> */}

              <Tag
                color={`${
                  stockType?.mode === "OPEN"
                    ? "#2db7f5"
                    : stockType?.mode === "UPDATE"
                    ? "#108ee9"
                    : "#87d068"
                }`}
              >
                {stockType?.mode}
              </Tag>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        //Add buttons in the page header
        extra={getActionButtons()}
      >
        <Page inner>
          <Spin tip="Loading..." spinning={isLoading}>
            <TabMenu menu="summary" id={id} statusOf={stockType?.mode} />
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                    name="code"
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input readOnly={true} placeholder="HS Code" />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="name" label="Name">
                    <Input readOnly={true} placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="secondaryCode" label="Product Code">
                    <Input readOnly={true} placeholder="Product Code" />
                  </Form.Item>
                </Col>
              </Row>

              <Col span={6}>
                {/* <Form.Item name={["qualityType", "id"]} label="Quality Type" rules={[
                  {
                    required: true,
                    message: "Quality Type is required",
                  },
                ]}>
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Quality Type"
                  >
                    {qualityTypes.map((t) => (
                      <Select.Option value={t.id} key={t.id}>
                        {t.name} ({t.code})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item> */}
              </Col>
              <Col span={6}></Col>

              {materialLines && (
                <Table
                  bordered
                  pagination={false}
                  columns={getLineColumns()}
                  dataSource={stockType.materials}
                  size="small"
                />
              )}
            </Form>
          </Spin>

          <Drawer
            title={`Edit Material `}
            width={360}
            onClose={onCloseAddEditStockItemDrawer}
            open={editDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Form
              name="addEdit-stock"
              layout="vertical"
              requiredMark={false}
              form={addEditStockItemForm}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name={"id"}>
                    <Input hidden />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["materialType", "code"]}
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input placeholder="HS Code" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["materialType", "secondaryCode"]}
                    label="Material Code"
                  >
                    <Input placeholder="Material Code" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["materialType", "name"]}
                    label="Description"
                  >
                    <Input placeholder="Description" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item name={"quantityPerUnit"} label="Quantity Per unit">
                    <Input placeholder="Quantity Per Unit" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item name={["uom", "name"]} label="UOM">
                    <Input disabled placeholder="uom" />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
            </Form>
            <div
              style={{
                position: "absolute",
                right: 0,
                bottom: 0,
                width: "100%",
                borderTop: "1px solid #e9e9e9",
                padding: "10px 16px",
                background: "#fff",
                textAlign: "right",
              }}
            >
              <Button
                onClick={onCloseAddEditStockItemDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleAddEditStockItem}
                type="primary"
                loading={loadingAddEditStockItem}
              >
                Submit
              </Button>
            </div>
          </Drawer>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
